import ApiService from '@/services/api.service'

const IBranchLocationService = {

    getAll(parameter) {              
          const requestData = {
            method: 'get',
            url: "/BranchLocations",
            headers: {
            },
            params: { 
              SearchCriteria: parameter.SearchCriteria,           
              PageSize: parameter.PageSize,          
              PageNumber : parameter.PageNumber,           
            }
          }     
          return ApiService.customRequest(requestData);         
        },    

        GetBranchLocations(){
            return ApiService.get(`/BranchLocations`);       
        },

        GetBranchLocation(id){
            return ApiService.get(`/BranchLocations/${id}`);
        },

}

export default IBranchLocationService;